import { render, staticRenderFns } from "./ReportReasonsForm.vue?vue&type=template&id=0754a2e0&scoped=true&"
import script from "./ReportReasonsForm.vue?vue&type=script&lang=ts&"
export * from "./ReportReasonsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportReasonsForm.vue?vue&type=style&index=0&id=0754a2e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754a2e0",
  null
  
)

export default component.exports